<!-- Ported from the Polaris kit: src/components/ui/dialog/DialogFooter.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { DialogClose } from 'reka-ui';
import { cn } from '../../lib/utils';
import { Button } from '../button';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  showCloseButton: { type: Boolean, required: false, default: false },
});
</script>

<template>
  <div
    data-slot="dialog-footer"
    :class="
      cn('flex flex-col-reverse gap-2 sm:flex-row sm:justify-end', props.class)
    "
  >
    <slot />
    <DialogClose v-if="showCloseButton" as-child>
      <Button variant="outline">{{ $t('POLARIS.DIALOG.CLOSE') }}</Button>
    </DialogClose>
  </div>
</template>
